import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import Dots from 'react-activity/lib/Dots';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import InviteSubscribersModal from '../subscribers/InviteSubscribersModal';
import Colors from '../../../../styles/colors';
import commonStyles from '../../../../styles/commonStyles';
import { LoadingWrapper } from '../../../../styles/styled';
import { OrangeSubmitButton, ActionButton } from '../../../../components/buttons/buttons';
import ReimportEpisodes from '../../../../components/support/ReimportEpisodes';
import SoundcastsTabs from '../../../../components/soundcasts_tabs';
import Loading from '../../../../components/Loading';
import SoundcastsBundles from '../soundcasts_bundles';
import SoundcastsConversions from '../soundcasts_conversions';
import SoundcastDraggable from './SoundcastDraggable';
import {
  isUserPlanAlive,
  hasUserExceededContentPlanLimit,
  getSoundcastsManagedv2,
  getSoundcastsManagedCountV2,
  isSoundcastsManagedLoaded,
  isSoundcastsManagedComplete,
  isSoundcastsManagedBusy,
  canUserAccessFeature,
} from '../../../../helpers/userinfoHelper';
import { ALERTS } from '../../../../helpers/texts';
import { getOrderFromProps, reorderInArray, createOrderedSoundcasts } from './sorting_utils';
const { isFreeAccount, isMonitoringAccount } = require('../../../../../server/scripts/utils.js')();

const ordersLoading = (nextProps) => {
  const { userInfo } = nextProps;
  const order = getOrderFromProps(nextProps);
  const {
    dashboardSoundcastIds: {
      busy: soundcastsOrderBusy = false,
      loaded: soundcastsOrderLoaded = false,
    },
    dashboardBundleIds: { busy: bundlesOrderBusy = false, loaded: bundlesOrderLoaded = false },
  } = order;

  if (!soundcastsOrderLoaded && !soundcastsOrderBusy) {
    nextProps.fetchManagedSoundcastsOrderCreator({
      publisherID: userInfo.publisherID,
    });
  }

  if (!bundlesOrderLoaded && !bundlesOrderBusy) {
    nextProps.fetchManagedBundlesOrderCreator({
      publisherID: userInfo.publisherID,
    });
  }

  return !soundcastsOrderLoaded || !bundlesOrderLoaded;
}

const getDraggableListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
});

export default class SoundcastsManaged extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      currentSoundcastID: '',
      currentSoundcast: null,
      soundcasts: [],
      showStatsModal: false,
      currentEpisode: null,
      replicationSubmitting: false,
      loading: true,
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Change Plan',
        onClose: () => {},
        upgrade: false,
      },
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.editSoundcast = this.editSoundcast.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleStatsModal = this.handleStatsModal.bind(this);
    this.deleteSoundcast = this.deleteSoundcast.bind(this);
    this.replicateSoundcast = this.replicateSoundcast.bind(this);
    this.handleSoundcastSignup = this.handleSoundcastSignup.bind(this);
    this.handleSoundcastCheckout = this.handleSoundcastCheckout.bind(this);
    this.isShownSoundcastSignup = this.isShownSoundcastSignup.bind(this);
    this.handleAddNewSoundcast = this.handleAddNewSoundcast.bind(this);
    this.showAlertModal = this.showAlertModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isSoundcastsManagedLoaded()) {
      return null;
    }

    if (ordersLoading(nextProps)) {
      return {
        loading: true,
      };
    }

    // when its busy and soundcasts data is not complete
    // keep showing the loading message
    const isBusy = isSoundcastsManagedBusy();
    const isComplete = isSoundcastsManagedComplete();
    if (isBusy && !isComplete) {
      return {
        loading: true,
      };
    }

    const soundcastsManaged = getSoundcastsManagedv2(soundcast => !soundcast.bundle);
    const soundcasts = createOrderedSoundcasts(soundcastsManaged, getOrderFromProps(nextProps));

    return {
      loading: false,
      soundcasts,
    };
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    // dropped in the same place
    if (result.source.index === result.destination.index) {
      return;
    }

    const soundcasts = reorderInArray(
      this.state.soundcasts,
      result.source.index,
      result.destination.index
    );

    this.setState({
      soundcasts,
    });

    const { userInfo } = this.props;
    this.props.updateManagedSoundcastsOrderCreator({
      publisherID: userInfo.publisherID,
      soundcasts,
    });
  }

  editSoundcastTracks(soundcastId) {
    const { history } = this.props;
    history.push(`/dashboard/soundcast/${soundcastId}`);
  }

  showSoundcastAnalytics(soundcastId) {
    const { history } = this.props;
    history.push({
      pathname: '/dashboard/analytics',
      state: { soundcastId },
    });
  }

  editSoundcast(soundcastId, soundcast) {
    const { history } = this.props;
    history.push({
      pathname: `/dashboard/edit/${soundcastId}`,
      state: {
        id: soundcastId,
        soundcast,
      },
    });
  }

  editEpisode(episode) {
    const { history } = this.props;
    history.push({
      pathname: `/dashboard/edit_episode/${episode.id}`,
      state: {
        id: episode.id,
        episode,
      },
    });
  }

  handleSoundcastSignup(soundcast) {
    return () => {
      if (!canUserAccessFeature('NON_PAYMENT_ACCESS_LINK')) {
        return this.showAlertModal({
          title: 'Upgrade Required',
          content: ALERTS().NON_PAYMENT_ACCESS_LINK.NO_ACCESS,
          upgrade: true,
        });
      }

      if (!soundcast.published) {
        return this.showAlertModal({
          content: 'Please publish the soundcast before you navigate to Non-payment signup page.',
          alertOnly: true,
        });
      }

      window.open(`/signup/soundcast_user/${soundcast.id}`, '_blank');
    };
  }

  handleSoundcastCheckout(soundcast) {
    return () => {
      if (!soundcast.published) {
        return this.showAlertModal({
          content: 'Please publish the soundcast before you navigate to Checkout page.',
          alertOnly: true,
        });
      }

      window.open(`/soundcast_checkout?soundcast_id=${soundcast.id}`, '_blank');
    };
  }

  isShownSoundcastSignup(soundcast) {
    const { userInfo } = this.props;
    if (isFreeAccount(userInfo)) {
      return false;
    }

    if (userInfo.publisher.plan === 'basic') {
      return true;
    }
    if (!soundcast.forSale) {
      return true;
    }
    if (
      soundcast.forSale === true &&
      !isFreeAccount(userInfo) &&
      (userInfo.publisher.plan === 'plus' ||
        userInfo.publisher.plan === 'pro' ||
        userInfo.publisher.plan === 'platinum') &&
      userInfo.publisher.current_period_end > moment().format('X')
    ) {
      return true;
    }
    return false;
  }

  handleAddNewSoundcast() {
    const { userInfo, history } = this.props;
    if (userInfo.publisher) {
      // add 1 as we are gonna add a new soundcast for verification
      // this will verify if we're gonna exceed adding soundcast
      const soundcastsCount = getSoundcastsManagedCountV2() + 1;
      if (hasUserExceededContentPlanLimit(soundcastsCount)) {
        return this.showAlertModal({
          title: 'Upgrade Required',
          content: ALERTS().ALLOWED_SOUNDCASTS.LIMIT_EXCEEDED,
          upgrade: true,
        });
      }

      history.push('/dashboard/add_soundcast');
    }
  }

  handleModal(soundcast = {}) {
    const { userInfo } = this.props;

    // verify plan
    if (!isUserPlanAlive(userInfo)) {
      return this.showAlertModal({
        content: `You need a valid subscription plan to access this feature`,
        subscribe: true,
      });
    }

    // make sure the soundcast is published
    if (!isEmpty(soundcast)) {
      const { published = false } = soundcast;
      if (!published) {
        return this.showAlertModal({
          content: 'Please publish your soundcast first before inviting listeners.',
          alertOnly: true,
        });
      }
    }

    if (!this.state.showModal) {
      this.setState({
        showModal: true,
        currentSoundcastID: soundcast.id,
        currentSoundcast: soundcast,
      });
    } else {
      this.setState({ showModal: false });
    }
  }

  handleStatsModal() {
    this.setState({ showStatsModal: !this.state.showStatsModal });
  }

  setCurrentEpisode(episode) {
    this.setState({ currentEpisode: episode });
    this.handleStatsModal();
  }

  async deleteSoundcast(soundcastId) {
    const { userInfo, managed } = this.props;
    const soundcastTitle = managed.soundcasts.byId[soundcastId].title;
    const confirmText = `Are you sure you want to delete ${soundcastTitle}? All information about this soundcast will be deleted, including subscribers' emails and audio files.`;
    if (confirm(confirmText)) {
      const soundcastFromYoutube = userInfo.publisher && userInfo.publisher.soundcastFromYoutube;
      const soundcastIds = Object.keys(soundcastFromYoutube || {});
      if (soundcastIds.some(i => i === soundcastId)) {
        // connected to youtube
        Axios.post('/api/parse_channel', {
          publisherId: userInfo.publisherID,
          creatorId: userInfo.id,
          soundcastId,
          deleteChannelSubscription: true,
        });
      }

      // delete the data from both firebase and postgres
      Axios.post('/api/delete_soundcast', {
        soundcastId,
        publisherId: userInfo.publisherID,
      }).then(() => {
        this.props.decreasePlanCurrentUsage({ type: 'podcast_feeds' });
        this.showAlertModal({
          content: 'Soundcast has been successfully deleted.',
          alertOnly: true,
        });
      });
    }
  }

  replicateSoundcast(soundcastId) {
    const { userInfo } = this.props;

    // verify plan
    if (!isUserPlanAlive(userInfo)) {
      return this.showAlertModal({
        content: `You need a valid subscription plan to access this feature`,
        subscribe: true,
      });
    }

    this.setState({ replicationSubmitting: true });
    Axios.post('/api/replicate_soundcast', {
      soundcastId,
      publisherId: userInfo.publisherID,
    })
      .then(result => {
        if (result && result.data && result.data.slice(0, 7) === 'Success') {
          return this.showAlertModal({
            content: [
              'Soundcast has been successfully replicated.',
              <br key="soundcast-replicated-br" />,
              'The copied soundcast is saved in draft.',
            ],
          });
        }

        throw new Error('Replication failed');
      })
      .catch(err => {
        console.error('Replication failed', err);
        this.showAlertModal({
          content: 'Soundcast replication failed.',
        });
      })
      .finally(() => {
        this.setState({ replicationSubmitting: false });
      });
  }

  alertModalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      subscribe = false,
      upgrade = false,
      alertOnly = false,
      onClose = false,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            subscribe,
            upgrade,
            alertOnly,
            onClose: !show ? false : onClose,
          },
        },
        () => oldClose && !show && oldClose()
      );
    };
  }

  showAlertModal(metadata = {}) {
    this.alertModalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, subscribe, upgrade, alertOnly } = this.state.modal;
    const actionBtnLabel = upgrade ? 'Upgrade' : subscribe ? 'Subscribe' : 'OK';
    const actionBtnClick =
      upgrade || subscribe
        ? () => this.props.history.push('/pricing')
        : this.alertModalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton onClick={actionBtnClick}>{actionBtnLabel}</ActionButton>
        {!alertOnly && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={this.alertModalHandler({ show: false })}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
            <div
              style={{ cursor: 'pointer', float: 'right', fontSize: 29 }}
              onClick={this.alertModalHandler({ show: false })}>
              &#10799; {/* Close button (X) */}
            </div>
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.alertModalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderReimportEpisodesBtn(soundcast) {
    // only available to monitoring accounts
    const { userInfo } = this.props;
    if (!isMonitoringAccount(userInfo)) {
      return null;
    }

    return <ReimportEpisodes soundcast={soundcast} />;
  }

  render() {
    const { soundcasts = [], loading } = this.state;
    const { userInfo, history, match } = this.props;
    const isFree = isFreeAccount(userInfo);
    const { publisher = {} } = userInfo;

    if (loading) {
      return (
        <LoadingWrapper height="90">
          <Loading text="Loading soundcasts, please wait" />
        </LoadingWrapper>
      );
    }

    if (!isFree && match.params.id == 'bundles') {
      return <SoundcastsBundles {...this.props} />;
    }

    if (!isFree && match.params.id == 'conversions') {
      return <SoundcastsConversions {...this.props} />;
    }

    return (
      <div style={{ minHeight: 700 }}>
        {(this.state.replicationSubmitting && (
          <div className="importing-feed-overlay" style={{ zIndex: 2 }}>
            <div style={styles.modalOverlay}>
              <div style={{ marginTop: 33 }}>The soundcast is being replicated. Please wait</div>
              <div style={{ marginTop: 17 }}>
                <Dots style={{}} color={Colors.mainOrange} size={22} speed={1} />
              </div>
            </div>
          </div>
        )) ||
          null}
        <InviteSubscribersModal
          isShown={this.state.showModal}
          soundcast={this.state.currentSoundcast}
          onClose={this.handleModal}
          userInfo={userInfo}
        />
        <SoundcastsTabs active="individuals" isFree={isFree} showAlertModal={this.showAlertModal} />

        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getDraggableListStyle(snapshot.isDraggingOver)}>
                {soundcasts.map((soundcast, index) => {
                  return (
                    <SoundcastDraggable
                      key={`soundcast-${soundcast.id}`}
                      index={index}
                      soundcast={soundcast}
                      publisher={publisher}
                      isMonitoringAccount={isMonitoringAccount(userInfo)}
                      onNonPaymentSignup={this.handleSoundcastSignup(soundcast)}
                      onCheckout={this.handleSoundcastCheckout(soundcast)}
                      onTracks={() => this.editSoundcastTracks(soundcast.id)}
                      onAnalytics={() => this.showSoundcastAnalytics(soundcast.id)}
                      onEdit={() => this.editSoundcast(soundcast.id)}
                      onDelete={() => this.deleteSoundcast(soundcast.id)}
                      onReplicate={() => this.replicateSoundcast(soundcast.id)}
                    />
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div className="row" style={{ ...styles.row, backgroundColor: 'transparent' }}>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <OrangeSubmitButton
              id="addNewSoundcastBtnTest"
              label="Add New Soundcast"
              onClick={() => this.handleAddNewSoundcast()}
            />
          </div>
          <MuiThemeProvider>{this.renderAlertModal()}</MuiThemeProvider>
        </div>
      </div>
    );
  }
}

SoundcastsManaged.propTypes = {
  userInfo: PropTypes.object,
  managed: PropTypes.object,
  history: PropTypes.object,
  id: PropTypes.string,
};

const styles = {
  input: { ...commonStyles.input },
  containerWrapper: { ...commonStyles.containerWrapper },
  titleText: {
    fontSize: 12,
  },
  row: {
    marginTop: 10,
    marginRight: 10,
    marginBottom: 10,
    marginLeft: 0,
    backgroundColor: Colors.mainWhite,
  },
  modalOverlay: {
    height: 120,
    width: 370,
    backgroundColor: 'white',
    position: 'fixed',
    border: '1px solid silver',
    zIndex: 1000,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 5,
    textAlign: 'center',
  },
};
